<div class="main_plus_side">
    <div class="sidesheet_temp mat-elevation-z2">
        <ng-container *ngIf="periodosNavBar">
            <nav-bar [navBarItems]="periodosNavBar" [initialValue]="periodoID" [placeholder]="'Seleccione un año'" [navOnChange]="true" [verticalLayout]="true"></nav-bar>
        </ng-container>
        <nivelaciones-convenciones [direccion]="'vertical'" [asistencia]="true" [data]="tiposAsistencia" [dataFilterValues]="['A', 'A0', 'A1', 'A2', 'A3', 'R', 'R0', 'R1', 'R2', 'R3']"></nivelaciones-convenciones>
    </div>
    <div class="main_sheet">
        <div class="flex-wrap" style="align-items:center;">
            <div class="inline-flex" style="width: 30%">
                <mat-form-field class="full-width">
                    <input matInput placeholder="Filtrar por nombre" (keyup)="filtroTexto($event.target.value)" autocomplete="off">
                </mat-form-field>
            </div>
            <span class="spacer"></span>
            <div class="flex-wrap" style="align-items:center;">
                <label style="margin-right: 4px; opacity:.6;">Ver valores como:</label>
                <button mat-button class="view-mode" [ngStyle]="{'color': viewMode != 'numbers' ? 'blue' : 'inherit', 'text-decoration': viewMode != 'numbers' ? 'underline' : 'none'}" (click)="changeViewMode('percentage')" [ngClass]="{'active': viewMode != 'numbers'}">Porcentaje
        </button>
                <button mat-button class="view-mode" [ngStyle]="{'color': viewMode == 'numbers' ? 'blue' : 'inherit', 'text-decoration': viewMode == 'numbers' ? 'underline' : 'none'}" (click)="changeViewMode('numbers')" [ngClass]="{'active': viewMode == 'numbers'}">Numérico
        </button>
            </div>
        </div>
        <div *ngIf="dataSource; else loading">
            <mat-table #table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                <ng-container matColumnDef="Curso">
                    <mat-header-cell *matHeaderCellDef style="flex: 3;">Curso</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 3;">{{element.nombre != null ? element.nombre : 'N/D'}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="FaltaTarea">
                    <mat-header-cell *matHeaderCellDef>Falta de tareas</mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <span *ngIf="element.faltaTareaAccumula > 0">
            {{element.faltaTareaAcumula}}
              </span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="AyR" style="text-align: center">
                    <mat-header-cell *matHeaderCellDef style="flex: 1; text-align: center;">Ausencias y retardos</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1; text-align: center;">
                        <div style="position: relative;">
                            <div class="circulo" style="cursor: pointer;" (click)="getDetails(element, element.id)">
                                <small>
                  {{viewMode == 'numbers' ? element.numerico : element.porcentaje + '%'}}
                </small>
                            </div>
                            <div *ngIf="element.detalle && element.detalle.show" class="detail-container mat-elevation-z24">
                                <ul class="detail-list">
                                    <li *ngFor="let alumnoDetalle of element.detalle.listaDetalles" class="flex-wrap">
                                        <p style="flex: 5; text-align: left">{{alumnoDetalle.alumno}}</p>
                                        <span class="spacer"></span>
                                        <p style="flex: 1; text-align: right">
                                            {{viewMode == 'numbers' ? alumnoDetalle.numerico : alumnoDetalle.porcentaje + '%'}}
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Alerta">
                    <mat-header-cell *matHeaderCellDef style="flex: 1; text-align: center;">
                        <mat-icon>warning</mat-icon>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1; text-align: center;">{{element.alertas}}</mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let element; columns: displayedColumns;">
                </mat-row>
            </mat-table>
        </div>
        <ng-template #loading>
            <mat-spinner [mode]="'indeterminate'"></mat-spinner>
        </ng-template>
    </div>
</div>